/** @module filter */

/**
 * Funktionalität des Filter-Typ "Input".
 */
export class InputFilter {
	constructor(item, wrapper, opaccFilterCriterias) {
		this.filterItem = item;
		this.wrapperItem = wrapper;
		this.opaccFilterCriterias = opaccFilterCriterias;

		this.setFilterValue();

	}


	/**
	 * Texteingabe als Filterwert vorbereiten und Enter Event auslösen
	 */
	setFilterValue() {
		let itemId = `#${this.filterItem.getAttribute('id')}`;
		let filterBtnSelector = `${itemId}-apply-btn`;

		this.wrapperItem.addEventListener('click', (e) => {
			let filterItem = e.target.closest(itemId);

			if (!filterItem) {
				return;
			}

			let inputFilterElem = filterItem.querySelector('.opc-input');
			if (!inputFilterElem) {
				return;
			}

			if (e.target.closest(filterBtnSelector)) {
				const eventDict = {
					altKey:false,
					bubbles: true,
					cancelBubble: false,
					cancelable: true,
					charCode: 0,
					code: 'Enter',
					composed: true,
					ctrlKey: false,
					currentTarget: null,
					defaultPrevented: true,
					detail: 0,
					eventPhase: 0,
					isComposing: false,
					isTrusted: true,
					key: 'Enter',
					keyCode: 13,
					location: 0,
					metaKey: false,
					repeat: false,
					returnValue: false,
					shiftKey: false,
					type: 'keydown',
					which: 13
				};

				let triggerEvent = new KeyboardEvent('keyup', eventDict);
				// trigger Keyboard Event
				inputFilterElem.dispatchEvent(triggerEvent);
			}
		});

	}
}